import { Capacitor } from '@capacitor/core'
import { useEffect } from 'react'
import { Outlet, useLocation, useOutlet } from 'react-router-dom'
import { useMediaQuery } from 'usehooks-ts'

import { breakpoints } from '@/config/layout'
import { ContentArea } from '@/layout/components/content-area/ContentArea'
import { ContentGrid } from '@/layout/components/content-layout/ContentLayout.styled'
import { useLayout } from '@/layout/providers/LayoutProvider'
import { useLeanSubject } from '@/modules/healthblocks/hooks/useLeanSubject'
import { useFeatureFlag } from '@/utils/feature-flag'
import { ProfileNav } from '../navigation/ProfileNav.page'

const ProfileRootPage = () => {
  const outlet = useOutlet()
  const { subject } = useLeanSubject()
  const location = useLocation()
  const olvw = useFeatureFlag('tenant_olvw') === '1'

  const isSmall = useMediaQuery(breakpoints.toS)
  const isMobile = Capacitor.isNativePlatform() || isSmall

  const { hideNavigation, showNavigation } = useLayout()

  // Effects
  // ------------------------------------------------------------------------- /
  useEffect(() => {
    if (isMobile) {
      hideNavigation()
    }

    return () => {
      showNavigation()
    }
  }, [isMobile, hideNavigation, showNavigation, location.pathname])

  useEffect(() => {
    if (subject) {
      // TODO Get health profile data from Synops
    }
  }, [subject])

  return (
    <ContentGrid>
      <ContentArea gridArea='content' divider={true}>
        <ProfileNav showSwitchTenant={olvw} />
      </ContentArea>
      {outlet ? (
        <ContentArea gridArea='content-detail' zIndex={1}>
          <Outlet />
        </ContentArea>
      ) : null}
    </ContentGrid>
  )
}

export { ProfileRootPage }
